<template>
    <el-dialog width="550px" :visible.sync="visible" :before-close="close" title="新增" :close-on-click-modal="false">
        <el-form class='form-item' ref="formRef" :model="form" :rules="rules" label-width="140px" size="mini">
            <el-form-item label="仓库编码" prop="qualificationTypeCode">
                <el-input v-model="form.qualificationTypeCode" disabled class="input-class"></el-input>
            </el-form-item>
            <el-form-item label="产权分类" prop="attachmentTypeList">
                <MSelect
                    :optionNum="'SRM_PROPERTY_RIGHT_TYPE'"
                    :value="form.attachmentTypeList"
                    :filterable="true"
                    :multiple="true"
                    @input="handleSelect"
                ></MSelect>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="save">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { addPhysicsQua,queryPwQualificationQueryCondition } from '../../../../../api/addPhysicalStorage.js';
import MSelect from '@/components/lots/otpSelect2/index';

export default {
    components: { MSelect },
    data() {
        return {
            visible: false,
            loading: false,
            form: {
                qualificationTypeCode: null,
                attachmentTypeList: []
            },
            rules: {
                attachmentTypeList: [{ required: true, message: '产权分类不能为空', trigger: ['blur', 'change'] }]
            }
        };
    },
    methods: {
        handleSelect(val) {
            this.form.attachmentTypeList = val;
        },
        open() {
            this.visible = true;
            this.form.qualificationTypeCode = this.$route.query.whCode;
        },
        close() {
            this.form = {
                qualificationTypeCode: null,
                attachmentTypeList: []
            };
            this.$refs.formRef.resetFields();
            this.visible = false;
        },
        save() {
         
            if(this.form.qualificationTypeCode){
                this.hasWarehouse();
            }
            else if(!this.form.qualificationTypeCode&&this.form.attachmentTypeList.length){
                this.loading = true;
                let params= {attachmentTypeList:this.form.attachmentTypeList}
                queryPwQualificationQueryCondition(params).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('资质新增成功');
                        this.close();
                        this.$emit('add-refresh',res.data);
                    }
                }).finally(() => {
                    this.loading = false; });

            }
        },
        hasWarehouse() {
            this.$refs.formRef.validate().then(res => {
                this.loading = true;
                addPhysicsQua({ ...this.form }).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('资质新增成功');
                            this.close();
                            this.$emit('refresh');
                        }
                    }).finally(() => { this.loading = false; });
            });
        }
    }
};
</script>